import AppProductPriceLegalNotice from './AppProductPriceLegalNotice';

export default AppProductPriceLegalNotice;
